import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then( m => m.DashboardPageModule)
  },
  {
    path: 'branches',
    loadChildren: () => import('./pages/branches/branches.module').then( m => m.BranchesPageModule)
  },
  {
    path: 'landing-slider',
    loadChildren: () => import('./pages/landing-slider/landing-slider.module').then( m => m.LandingSliderPageModule)
  },
  {
    path: 'result-overview',
    loadChildren: () => import('./pages/result-overview/result-overview.module').then( m => m.ResultOverviewPageModule)
  },
  {
    path: 'result-modal',
    loadChildren: () => import('./pages/result-modal/result-modal.module').then( m => m.ResultModalPageModule)
  },
  {
    path: 'courses',
    loadChildren: () => import('./pages/courses/courses.module').then( m => m.CoursesPageModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/signup/signup.module').then( m => m.SignupPageModule)
  },
  {
    path: 'subjects',
    loadChildren: () => import('./pages/subjects/subjects.module').then( m => m.SubjectsPageModule)
  },
  {
    path: 'admission-form',
    loadChildren: () => import('./pages/admission-form/admission-form.module').then( m => m.AdmissionFormPageModule)
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'activities-video',
    loadChildren: () => import('./pages/activities-video/activities-video.module').then( m => m.ActivitiesVideoPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'testimonials',
    loadChildren: () => import('./pages/testimonials/testimonials.module').then( m => m.TestimonialsPageModule)
  },
  {
    path: 'gallery',
    loadChildren: () => import('./pages/gallery/gallery.module').then( m => m.GalleryPageModule)
  },
  {
    path: 'chairman-message',
    loadChildren: () => import('./pages/chairman-message/chairman-message.module').then( m => m.ChairmanMessagePageModule)
  },
  {
    path: 'about-us',
    loadChildren: () => import('./pages/about-us/about-us.module').then( m => m.AboutUsPageModule)
  },
  {
    path: 'our-team',
    loadChildren: () => import('./pages/our-team/our-team.module').then( m => m.OurTeamPageModule)
  },
  {
    path: 'awards-achievements',
    loadChildren: () => import('./pages/awards-achievements/awards-achievements.module').then( m => m.AwardsAchievementsPageModule)
  },
  {
    path: 'enquiry',
    loadChildren: () => import('./pages/enquiry/enquiry.module').then( m => m.EnquiryPageModule)
  },
  {
    path: 'map',
    loadChildren: () => import('./pages/map/map.module').then( m => m.MapPageModule)
  },
  {
    path: 'online-test',
    loadChildren: () => import('./pages/online-test/online-test.module').then( m => m.OnlineTestPageModule)
  },
  {
    path: 'test-paper',
    loadChildren: () => import('./pages/test-paper/test-paper.module').then( m => m.TestPaperPageModule)
  },
  {
    path: 'timetable',
    loadChildren: () => import('./pages/timetable/timetable.module').then( m => m.TimetablePageModule)
  },
  {
    path: 'questionnumbers-modal',
    loadChildren: () => import('./pages/questionnumbers-modal/questionnumbers-modal.module').then( m => m.QuestionnumbersModalPageModule)
  },
  {
    path: 'home-admin',
    loadChildren: () => import('./pages/home-admin/home-admin.module').then( m => m.HomeAdminPageModule)
  },
  {
    path: 'home-faculty',
    loadChildren: () => import('./pages/home-faculty/home-faculty.module').then( m => m.HomeFacultyPageModule)
  },
  {
    path: 'attendance',
    loadChildren: () => import('./pages/attendance/attendance.module').then( m => m.AttendancePageModule)
  },
  {
    path: 'media',
    loadChildren: () => import('./pages/media/media.module').then( m => m.MediaPageModule)
  },
  {
    path: 'announcement',
    loadChildren: () => import('./pages/announcement/announcement.module').then( m => m.AnnouncementPageModule)
  },
  {
    path: 'study-material',
    loadChildren: () => import('./pages/study-material/study-material.module').then( m => m.StudyMaterialPageModule)
  },
  {
    path: 'study-material-detail',
    loadChildren: () => import('./pages/study-material-detail/study-material-detail.module').then( m => m.StudyMaterialDetailPageModule)
  },
  {
    path: 'notifications',
    loadChildren: () => import('./pages/notifications/notifications.module').then( m => m.NotificationsPageModule)
  },
  {
    path: 'online-class',
    loadChildren: () => import('./pages/online-class/online-class.module').then( m => m.OnlineClassPageModule)
  },
  {
    path: 'admin-admission',
    loadChildren: () => import('./pages/admin/admin-admission/admin-admission.module').then( m => m.AdminAdmissionPageModule)
  },
  {
    path: 'admin-collection',
    loadChildren: () => import('./pages/admin/admin-collection/admin-collection.module').then( m => m.AdminCollectionPageModule)
  },
  {
    path: 'admin-royalty',
    loadChildren: () => import('./pages/admin/admin-royalty/admin-royalty.module').then( m => m.AdminRoyaltyPageModule)
  },
  {
    path: 'book-demo',
    loadChildren: () => import('./pages/book-demo/book-demo.module').then( m => m.BookDemoPageModule)
  },
  {
    path: 'home-demo',
    loadChildren: () => import('./pages/home-demo/home-demo.module').then( m => m.HomeDemoPageModule)
  },
  {
    path: 'faculty-datesheet',
    loadChildren: () => import('./pages/faculty/faculty-datesheet/faculty-datesheet.module').then( m => m.FacultyDatesheetPageModule)
  },
  {
    path: 'faculty-test-result',
    loadChildren: () => import('./pages/faculty/faculty-test-result/faculty-test-result.module').then( m => m.FacultyTestResultPageModule)
  },
  {
    path: 'faculty-study-material',
    loadChildren: () => import('./pages/faculty/faculty-study-material/faculty-study-material.module').then( m => m.FacultyStudyMaterialPageModule)
  },
  {
    path: 'faculty-test-overview',
    loadChildren: () => import('./pages/faculty/faculty-test-overview/faculty-test-overview.module').then( m => m.FacultyTestOverviewPageModule)
  },
  {
    path: 'faculty-calendar',
    loadChildren: () => import('./pages/faculty/faculty-calendar/faculty-calendar.module').then( m => m.FacultyCalendarPageModule)
  },
  {
    path: 'faculty-online-class',
    loadChildren: () => import('./pages/faculty/faculty-online-class/faculty-online-class.module').then( m => m.FacultyOnlineClassPageModule)
  },
  {
    path: 'faculty-messages',
    loadChildren: () => import('./pages/faculty/faculty-messages/faculty-messages.module').then( m => m.FacultyMessagesPageModule)
  },
  {
    path: 'faculty-gallery',
    loadChildren: () => import('./pages/faculty/faculty-gallery/faculty-gallery.module').then( m => m.FacultyGalleryPageModule)
  },
  {
    path: 'faculty-attendance',
    loadChildren: () => import('./pages/faculty/faculty-attendance/faculty-attendance.module').then( m => m.FacultyAttendancePageModule)
  },
  {
    path: 'admin-attendance',
    loadChildren: () => import('./pages/admin/admin-attendance/admin-attendance.module').then( m => m.AdminAttendancePageModule)
  },
  {
    path: 'admin-request',
    loadChildren: () => import('./pages/admin/admin-request/admin-request.module').then( m => m.AdminRequestPageModule)
  },
  {
    path: 'feedback',
    loadChildren: () => import('./pages/feedback/feedback.module').then( m => m.FeedbackPageModule)
  },
  {
    path: 'monthly-calendar',
    loadChildren: () => import('./pages/monthly-calendar/monthly-calendar.module').then( m => m.MonthlyCalendarPageModule)
  },
  {
    path: 'fee-payments',
    loadChildren: () => import('./pages/fee-payments/fee-payments.module').then( m => m.FeePaymentsPageModule)
  },
  {
    path: 'games',
    loadChildren: () => import('./pages/games/games.module').then( m => m.GamesPageModule)
  },
  {
    path: 'about-developer',
    loadChildren: () => import('./pages/about-developer/about-developer.module').then( m => m.AboutDeveloperPageModule)
  },
  {
    path: 'about-institute',
    loadChildren: () => import('./pages/about-institute/about-institute.module').then( m => m.AboutInstitutePageModule)
  },
  {
    path: 'recorded-home',
    loadChildren: () => import('./pages/recorded/recorded-home/recorded-home.module').then( m => m.RecordedHomePageModule)
  },
  {
    path: 'recorded-materials',
    loadChildren: () => import('./pages/recorded/recorded-materials/recorded-materials.module').then( m => m.RecordedMaterialsPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
